// useInventarioXL - Sprint 44 Fase 3 Vista 5.
// Hook de inventario valorizado: filtros (con_stock, busqueda local),
// estado loading/err. Reusa /productos/inventario sin cambiar contrato.
// msg auto-dismiss 4s.
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import apiClient from '../../../api/apiClient';

const MSG_AUTO_DISMISS_MS = 4000;

export default function useInventarioXL() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [valorizacionTotal, setValorizacionTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const [conStock, setConStock] = useState('');
  const [q, setQ] = useState('');
  const [msg, setMsg] = useState(null);

  const msgTimer = useRef(null);
  const pushMsg = useCallback((kind, text) => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
    setMsg({ kind, text });
    msgTimer.current = setTimeout(() => setMsg(null), MSG_AUTO_DISMISS_MS);
  }, []);
  useEffect(() => () => {
    if (msgTimer.current) clearTimeout(msgTimer.current);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const params = new URLSearchParams();
      if (conStock) params.set('con_stock', conStock);
      const r = await apiClient.get('/productos/inventario?' + params.toString());
      const d = (r && r.data) || {};
      setItems(d.items || []);
      setTotal(d.total || 0);
      setValorizacionTotal(d.valorizacion_total || 0);
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar inventario');
      setItems([]); setTotal(0); setValorizacionTotal(0);
    } finally {
      setLoading(false);
    }
  }, [conStock]);

  useEffect(() => { load(); }, [load]);

  // Filtro local en cliente por nombre / codigo / categoria
  const filtered = useMemo(() => {
    const ql = (q || '').trim().toLowerCase();
    if (!ql) return items;
    return items.filter((p) => (
      (p.codigo || '').toLowerCase().includes(ql)
      || (p.nombre || '').toLowerCase().includes(ql)
      || (p.categoria || '').toLowerCase().includes(ql)
    ));
  }, [items, q]);

  return {
    items: filtered,
    rawItems: items,
    total, valorizacionTotal,
    loading, err,
    conStock, setConStock,
    q, setQ,
    msg, pushMsg, clearMsg: () => setMsg(null),
    load,
  };
}
